import { Box, Typography, useTheme } from "@mui/material";
import Header from "../../components/Header";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../../theme";

const FAQ = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const questions = [
        {
            q: "An Important Question",
            a: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis officiis vero deserunt. Fugit facilis assumenda ut aut dolor? Odio, porro!"
        },
        {
            q: "Another Question",
            a: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis officiis vero deserunt. Fugit facilis assumenda ut aut dolor? Odio, porro!"
        },
        {
            q: "A Simple Question",
            a: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis officiis vero deserunt. Fugit facilis assumenda ut aut dolor? Odio, porro!"
        }, {
            q: "What is Capex and Opex",
            a: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis officiis vero deserunt. Fugit facilis assumenda ut aut dolor? Odio, porro!"
        },
        {
            q: "The Final Question",
            a: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis officiis vero deserunt. Fugit facilis assumenda ut aut dolor? Odio, porro!"
        }
    ];


    return <Box m="20px" >
        <Header title="FAQ" subtitle="Frequently Asked Questions Page" />

        {questions.map((question) => {
            return <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography color={colors.greenAccent[500]} variant="h5">
                        {question.q}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        {question.a}
                    </Typography>
                </AccordionDetails>
            </Accordion>
        })}


    </Box>
}
export default FAQ;